export default __webpack_public_path__ + "89d9216929bc72c59fdd9a005854dbc4.jpg";